import React, { useEffect } from 'react'
import {
    unstable_HistoryRouter as HistoryRouter,
    Routes,
    Route
} from 'react-router-dom'
import { ProtectedRoutes } from './ProtectedRoutes'
import { NetworkNavbar } from './NetworkNavbar'
import { Login, SentrySmokeTestPage } from '../pages'
import { customHistory } from './customHistory'
import { getConnectUser, getStaffRouterKey } from 'helpers'
import FcConnectRoutes from 'fc/navigation/ConnectRoutes'
import veConnectRoutes from 've/navigation/ConnectRoutes'
import { useAnalytics, useAppSelector } from 'hooks'

export const AppConnectRoutes = () => {
    const { response } = useAppSelector((store) => store.auth)
    const { trackPageView, updateUserInfo } = useAnalytics()
    const user = response?.user || getConnectUser()

    // Tag every Matomo visit with the logged-in user and role, not only the
    // visits that pass through the Login or Home pages.
    useEffect(() => {
        updateUserInfo(user?.username, user?.role)
    }, [user?.username, user?.role])

    useEffect(() => {
        const unlisten = customHistory.listen(() => {
            const splittedPath = customHistory.location.pathname.split('/')
            const pageName = splittedPath[1]
            // Ignore history change when navigating to village without an SFID
            // such as /village/villageSFID
            // Because every time we navigate to the village page there is an extra call
            if (pageName !== 'village' || splittedPath.length > 1) {
                trackPageView({
                    documentTitle: customHistory.location.pathname.split('/')[1]
                })
            }
        })

        return () => {
            unlisten()
        }
    }, [customHistory])

    const staffRouter = {
        VE: veConnectRoutes,
        FC: FcConnectRoutes
    }
    const routerKey = getStaffRouterKey(user?.role)

    return (
        <HistoryRouter history={customHistory}>
            {user?.role && <NetworkNavbar user={user} />}
            <Routes>
                <Route path="login" element={<Login />} />
                <Route path="/" element={<ProtectedRoutes />}>
                    {process.env.REACT_APP_ENVIRONMENT &&
                        process.env.REACT_APP_ENVIRONMENT !== 'production' && (
                            <Route
                                path="debug/sentry-test"
                                element={<SentrySmokeTestPage />}
                            />
                        )}
                    {routerKey && staffRouter[routerKey]?.()}
                </Route>
                <Route path="*" element={<ProtectedRoutes />} />
            </Routes>
        </HistoryRouter>
    )
}
